import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useCallback, useMemo } from 'react';
import CallHistoryListItemV2 from 'flow/components/call-history-v2/CallHistoryListItemV2';
import { firstIndexToFocus } from 'flow/components/nav/list-keys/list-key-action';
import { callHistoryDates, callHistoryRowKey, rowIsFocusable, rowOpensCallRecord } from './call-history-rows';
import DateGroupedList from './DateGroupedList';
import { jsx as _jsx } from "react/jsx-runtime";
var DateGroupedCallRecordList = function DateGroupedCallRecordList(_ref) {
  var dateGroups = _ref.dateGroups,
    selectedCallRecordKey = _ref.selectedCallRecordKey,
    bgClassName = _ref.bgClassName;
  var dates = useMemo(function () {
    return callHistoryDates(dateGroups);
  }, [dateGroups]);

  // Tab enters at the row whose call record page is open, else at the
  // first row.
  var selectedOrFirstIndex = useCallback(function (rows) {
    var selectedIndex = rows.findIndex(function (row) {
      return rowOpensCallRecord(row, selectedCallRecordKey);
    });
    return selectedIndex === -1 ? firstIndexToFocus(rows, rowIsFocusable) : selectedIndex;
  }, [selectedCallRecordKey]);

  // A row's own control is its link to the call, or its first button
  // when it has no link, as a voicemail without a call record.
  var renderRow = function renderRow(row, rowProps) {
    return /*#__PURE__*/_jsx(CallHistoryListItemV2, _objectSpread({
      callRecordKey: row.kind === 'callRecord' ? row.callRecordKey : undefined,
      voiceMessage: row.kind === 'voiceMessage' ? row.voiceMessage : undefined,
      isFocusable: rowIsFocusable(row),
      isSelected: rowOpensCallRecord(row, selectedCallRecordKey)
    }, rowProps));
  };
  return /*#__PURE__*/_jsx(DateGroupedList, {
    dates: dates,
    rowKey: callHistoryRowKey,
    rowIsFocusable: rowIsFocusable,
    entryIndex: selectedOrFirstIndex,
    renderRow: renderRow,
    bgClassName: bgClassName
  });
};
export default DateGroupedCallRecordList;